export const BASE_SCOPES = [
    {
        value: 1,
        label: 'Scope 1 - Direct Green House gas Emissions',
    },
    {
        value: 2,
        label: 'Scope 2 - Electricity Indirect Green House Gas Emissions',
    },
    {
        value: 3,
        label: 'Scope 3 - Other Indirects Green House Gas Emissions',
    },
    {
        value: 0,
        label: 'Out of scope',
    },
];

export const SCOPE_OPTIONS = [
    {
        value: 'scope_1',
        label: 'Scope 1',
    },
    {
        value: 'scope_2',
        label: 'Scope 2',
    },
    {
        value: 'scope_3',
        label: 'Scope 3',
    },
    {
        value: 'no_scope',
        label: 'Out of scope',
    },
]

export const SCOPES = {
    0: '1.1 Mobil förburkning Distance, fuel or spend based method Distance, quantity and vehicle/combustion type',
    1: '1.2 Fast förburkning Fuel-based Quantity',
    2: '2.1 El Supplier specific, market specific or geagraphic location Suplier data, electricity bill, quantities used and/or pruchased',
    3: '2.2 Fjärrvärme Supplier specific, market specific or geagraphic location Suplier data, electricity bill, quantities used and/or pruchased',
    4: '2.3 Fjärrskyla Supplier specific, market specific or geagraphic location Suplier data, electricity bill, quantities used and/or pruchased',
    5: '3.1 Köpta varor och tjänster Supplier scope 1 och 2 data Supplier specific and average data. Average data with or without spend-based accpunting Kvantiteter av köpta tjänster och produkter',
    6: '3.2 Capital goods Supplier specific method with inventory. Hybrid method. Average method Kvantiteter av köpta tjänster och produkter',
    7: '3.3 Fuel and energy related activities Supplier specific or average method Quantities and types of fuels consumed',
    8: '3.4 Upstream transportation and distribution Fuel-based, distance-based or spend-based within each transportation method Quantities of fuels, ammount spent on fuels, quantities of fugitive emisisons, or distance travelled with average fuel efficiency',
    9: '3.5 Waste generated in operations Supplier specific, waste-type-specific method. Average data method Allocated scope 1 and 2 emissions from waste treatment company- Waste produced (quantity) and type of waste and treatemnt method',
    10: '3.6 Business travel Fuel-based, distance-based or spend-based method Toptal distance travelled and how. If applicable country specific travel and hotel, passenger specific vehicle type and privider vehicle type',
    11: '3.7 Employee commuting Fuel-based, distance-based ocr average data Amount spent on fuels by employee, Same as cat.4. Total distance travelled by type of vehicle,',
    12: '3.8 Upstream leased assets Asset-specific method (collecting asset specific data for scope 1 and 2) or lessor spevific method (collect from supplier) or average method Asset specific fuel use (steam, heating and cooling) or activity date to industrial process etc.',
    13: '3.9 Downstream transportation and distribution Same as cat.4 Distance (estimated or verified) using map etc.',
    14: '3.10 Processing of sold products Site specific method, average-data method Relevant activity data and relevant emisison factor',
    15: '3.11 Use of sold products Direct-use phase or indirect use-phase Total life time of product, quantities sold, fuel used by product, electricity consumption per product, refrigerant lekage',
    16: '3.12 End-of-life treatment of sold products Same as cat5. total mass of sold products and packaging from the point of sale. Proportion of waste treatment',
    17: '3.13 Downstream leased assets Same as cat8. Same as cat8.',
    18: '3.14 Franchises Franchise specific method Scope 1 and 2 emisison from franshise department',
    19: '3.15 Investments Invetsee specific method Scope 1 and 2 emisison from invetsement',
}
